// export default () => ({
// })

export default () => ({
    products: [],
    productsSelectable: [],
    productListByTypeProductClientSelectable: [],
    productSelect: null,
    productsPaginatedData: null,
    product: null,
    isLoading: false,
    isCreating: false,
    createdData: null,
    isUpdating: false,
    updatedData: null,
    isDeleting: false,
    deletedData: null,
    productsByLoteData: null,
    isLoadingProductsByLote: false,
    productByNamePresentationClient: null,
    productByNamePresentationClientIsCreating: false,
    productByNamePresentationClientTotalAmountUnitIsCreating: false,
    productByNamePresentationClientTotalAmountUnit: null,
    productListByClientSelectable: [],
    isLoadingProductListByClient: false,
})